import { SignatureErrorDetailsText } from './ErrorDetails.locstring.json';
import loc from 'owa-localize';
import Section from './Section';
import getSmimeSignatureErrorMessages from '../../utils/getSmimeSignatureErrorMessages';
import { observer } from 'mobx-react';

import * as React from 'react';

interface ErrorDetailsProps {
    serverVerificationResult?: number;
}

const ErrorDetails = (props: ErrorDetailsProps) => {
    const smimeSignatureErrorMessages: string[] = getSmimeSignatureErrorMessages(
        props.serverVerificationResult
    );

    if (!smimeSignatureErrorMessages?.length) {
        return null;
    }

    return (
        <Section title={loc(SignatureErrorDetailsText)}>
            {smimeSignatureErrorMessages.map((smimeSignatureError, index) => {
                return <div key={`${smimeSignatureError + index}`}>{smimeSignatureError}</div>;
            })}
        </Section>
    );
};

export default observer(ErrorDetails);
